import React from 'react';
import {format, parseISO} from 'date-fns';
import {getLanguage, t} from 'react-switch-lang';
import {FINDING_STATUS, RISK_LEVEL} from '../../../../const';

const FindingTrailComment = ({comment}) => {
  const {
    insertedAt,
    descriptionEn,
    description,
    user,
    newValue,
    oldValue,
    actionCode,
    oldValueEn,
    newValueEn,
    finding,
  } = comment;
  const lang = getLanguage();

  const makeInitials = () => {
    const initials = [];
    if (user.firstName) initials[0] = user.firstName[0];

    if (user.lastName) initials[1] = user.lastName[0];

    return initials.join('');
  };

  const avatar = user.imageUrl ? (
    <img src={user.imageUrl} alt='Avatar' />
  ) : (
    `${makeInitials()}`
  );
  const showChanges = () => {
    let text = (actionCode !== 'finding-departments-involved-changed' && actionCode !== 'finding-created'
        && actionCode !== 'finding-content-changed' && actionCode !== 'finding-proposed-action-changed' && actionCode !== "finding-management-response" && actionCode !== "finding-users-involved-changed" && actionCode !== "finding-completed" && actionCode !== "finding-aborted")
      ? (oldValue !== null) ? (lang === 'eng' ? ' from ' : ' iz ') : ((lang === 'eng' ? ' to ' : ' u ')) : '';
    switch (actionCode) {
      case 'finding-departments-involved-changed':
        lang === 'mne' ? text += '. ' + '"' + ((oldValue !== null) ? (t('revisions.removed') + oldValue + '; ') : '') + ((newValue !== null) ? (t('revisions.added') + newValue) : '') + '"'
          : text += '. ' + '"' + ((oldValueEn !== null) ? (t('revisions.removed') + oldValueEn + '; ') : '') + ((newValueEn !== null) ? (t('revisions.added') + newValueEn) : '') + '"';
        break;
      case 'finding-users-involved-changed':
         text += '. ' + '"' + ((oldValue !== null) ? (t('revisions.removed') + oldValue + '; ') : '') + ((newValue !== null) ? (t('revisions.added') + newValue) : '') + '"'
        break;
      case 'finding-name-changed':
        lang === 'eng' ? text += '"' + oldValue + '"'+' to '+'"' + newValue + '"' : text += '"' + oldValue + '"'+ ' u '+'"' + newValue + '"';
        break;
      case 'finding-status-changed':
        lang === 'eng' ? text += '"' + FINDING_STATUS[oldValue].en +'"'+ ' to '+'"' + FINDING_STATUS[newValue].en + '"' : text += '"' + FINDING_STATUS[oldValue].mne + '"'+' u '+'"' + FINDING_STATUS[newValue].mne + '"';
        break;
      case 'finding-initial-deadline-changed':
        text += '"' + format(parseISO(oldValue), 'dd.MM.yyyy.') +'"'+ (lang === 'eng' ? ' to ' : ' u ') +'"'+ format(parseISO(newValue), 'dd.MM.yyyy.') + '"';
        break;
      case 'finding-adjusted-deadline-changed':
        text += '"' + (oldValue ? (format(parseISO(oldValue), 'dd.MM.yyyy.') +'"' + (lang === 'eng' ? ' to ' : ' u ') +'"') : '') + format(parseISO(newValue), 'dd.MM.yyyy.') + '"';
        break;
      case 'finding-risk_level-changed':
        lang === 'eng' ? text += '"' + RISK_LEVEL[oldValue].en + '"' + ' to '+ '"' + RISK_LEVEL[newValue].en + '"' : text += '"' + RISK_LEVEL[oldValue].mne + '"' +' u '+'"' + RISK_LEVEL[newValue].mne + '"';
        break;
      case 'finding-responsible-user-changed':
        lang === 'eng' ? text += '"' + oldValue + '"' + ' to ' + '"'+ newValue + '"' : text += '"' + oldValue + '"' + ' u ' + '"' + newValue + '"';
        break;
      case 'finding-progress-percentage-changed':
        lang === 'eng' ? text += '"' + oldValue + '%' + '"' + ' to ' + '"'+ newValue + '%' + '"' : text += '"' + oldValue+ '%'  + '"' + ' u ' + '"' + newValue+ '%' + '"';
        break;
      case 'responsible-user-finding-status-changed':
        lang === 'eng' ? oldValue !== null ? (text += '"' + FINDING_STATUS[oldValue]?.en +'"'+ ' to '+'"' + FINDING_STATUS[newValue]?.en + '"') : text += FINDING_STATUS[newValue]?.en : oldValue !== null ? (text += '"' + FINDING_STATUS[oldValue]?.mne + '"'+' u '+'"' + FINDING_STATUS[newValue]?.mne + '"') : text += '"' + FINDING_STATUS[newValue]?.mne + '"';
        break;
      default:
        break;
    }


    return text;
  };

  return (
    <div className='document-comment' style={{maxWidth: "90%"}}>
      <div className='document-comment__image'>
        <div className='avatar-pic avatar-user'>{avatar}</div>
      </div>
      <div className='document-comment__data'>
        <div className='document-comment__info'>
          <p className='document-comment__author'>
            {user.firstName + ' ' + user.lastName}
          </p>
          <p className='document-comment__date'>
            {format(parseISO(insertedAt), 'dd.MM.yyyy. | HH:mm') + ' h'}
          </p>
        </div>
        <div className='document-comment__text'>
          <p>
            {lang === 'eng' ? descriptionEn : description}
            {<b>{showChanges()}</b>}
          </p>
          {}
        </div>
      </div>
    </div>
  );
};

export default FindingTrailComment;
